import { NgModule } from '@angular/core';
import { FinicityService } from '@app/shared/services/finicity/finicity.service';
import { AgentNoteService } from '@app/shared/services/agent-note/agent-note.service';
import { BankLinkingService } from '@app/shared/services/bank-linking/bank-linking.service';
import { PersonalLoanConfigurationService } from '@app/pages/personal-loans/shared/services/personal-loan-configuration.service';

@NgModule({
  declarations: [
  ],
  imports: [
  ],
  providers: [
    AgentNoteService,
    BankLinkingService,
    FinicityService,
    PersonalLoanConfigurationService
  ]
})
export class FinicityModule {}
